// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FiltersInstitution_filters-institution__doPno {
  max-width: 300px;
  width: 100%;
}

@media only screen and (max-width: 1200px) {
  .FiltersInstitution_filters-institution__doPno {
    max-width: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionList/Components/FiltersInstitution/FiltersInstitution.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;AACF;;AAEA;EACE;IACE,kBAAA;EACF;AACF","sourcesContent":[".filters-institution {\n  max-width: 300px;\n  width: 100%;\n}\n\n@media only screen and (max-width: 1200px) {\n  .filters-institution {\n    max-width: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters-institution": `FiltersInstitution_filters-institution__doPno`
};
export default ___CSS_LOADER_EXPORT___;
